import { useIntl } from "react-intl";
import { useFilterOverlay } from "../FilterOverlay/FilterOverlayContext";
import { Select } from "@certa/catalyst/components/Select";
import { useMemo } from "react";
import { useGetExtraJSON } from "@certa/queries/hooks/common.hook";

const SingleSelectFilter = () => {
  const intl = useIntl();
  const { searchValue, setSearchValue, filterProps } = useFilterOverlay();

  const { data: optionsFromApi, isLoading } = useGetExtraJSON(
    filterProps?.optionUrl ?? "",
    {
      enabled: !!filterProps?.optionUrl && !filterProps?.options?.length
    }
  );

  const onFilterSelect = (filter: string) => {
    setSearchValue(filter);
  };

  const defaultLabel = intl.formatMessage({
    id: "common.selectAnOption",
    defaultMessage: "Select an option"
  });

  const options = useMemo(() => {
    if (filterProps?.options)
      return filterProps?.options?.map(option => ({
        label: option.label,
        value: String(option.value)
      }));

    if (optionsFromApi?.results?.length) return optionsFromApi.results;
    return [];
  }, [filterProps?.options, optionsFromApi?.results]);

  return (
    <Select
      value={searchValue}
      onChange={onFilterSelect}
      menuPortalTarget={document.body}
      width="15.625rem"
      label={filterProps?.label || defaultLabel}
      placeholder={filterProps?.label || defaultLabel}
      options={options}
      isSearchable
      isClearable
      isLoading={isLoading}
    />
  );
};

export { SingleSelectFilter };
